import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useDrugAllergies = (patientId) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["drugAllergies", tenantVal, patientId],
    queryFn: async () => {
      if (!patientId || !tenantVal) return [];
      
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/allergy/drugallergies/patient/${patientId}`
      );
      return response.data || [];
    },
    enabled: !!patientId && !!tenantVal,
    staleTime: 1000 * 60 * 5,
    meta: { errorMessage: "Error fetching drug allergies" },
  });
};